import { LOCALSTORAGE_USER_CACHE_PREFIX } from "constants/index";

function evictCacheEntry(): boolean {
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(LOCALSTORAGE_USER_CACHE_PREFIX)) {
      localStorage.removeItem(key);
      return true;
    }
  }
  return false;
}

/**
 * Writes to localStorage, evicting a brev-user-cache-* entry on
 * QuotaExceededError and retrying until the write succeeds or there are no
 * more cache entries to evict.
 */
export function safeLocalStorageSetItem(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    if (!(e instanceof DOMException && e.name === "QuotaExceededError")) return;

    while (evictCacheEntry()) {
      try {
        localStorage.setItem(key, value);
        return;
      } catch {
        // keep evicting
      }
    }
  }
}
